import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonColor, SafeHtmlPipe } from '@cf/core';
import { CheckboxComponent } from '@cf/shared/forms/primitives';
import { ButtonComponent } from '@cf/shared/ui/button';
import { TextComponent } from '@cf/shared/ui/typography';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalHeaderComponent } from '../../components/modal-header/modal-header.component';
@Component({
  selector: 'cf-confirmation',
  template: `
    <div class="modal-wrapper">
      <div cf-modal-header [heading]="heading" [hideCloseButton]="true"></div>

      <div class="modal-body">
        <div class="row">
          <div class="col-12">
            <cf-text color="grey-70" *ngIf="text">
              <span class="text-break" [innerHTML]="text | safeHtml"></span>
            </cf-text>
          </div>
        </div>
        @if (checkBoxTitle) {
          <div class="row mt-12">
            <div class="col-12 p-1">
              <cf-checkbox labelClasses="tw:items-start" [(ngModel)]="checkBoxValue">
                <span [innerHTML]="checkBoxTitle | safeHtml"></span>
              </cf-checkbox>
            </div>
          </div>
        }
      </div>

      <div class="modal-footer">
        <cf-button color="secondary" (click)="activeModal.close(false)">
          {{ cancelButtonName }}
        </cf-button>
        <cf-button
          *ngIf="confirmationButton"
          (click)="
            activeModal.close(checkBoxTitle ? { checkBoxValue: checkBoxValue, submit: true } : true)
          "
          [color]="buttonColor"
        >
          {{ confirmationButton }}
        </cf-button>
      </div>
    </div>
  `,
  styleUrls: ['./confirmation.modal.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ModalHeaderComponent,
    NgIf,
    TextComponent,
    FormsModule,
    ButtonComponent,
    SafeHtmlPipe,
    CheckboxComponent,
  ],
})
export class ConfirmationModalComponent {
  @Input() heading!: string;

  @Input() text!: string;

  @Input() confirmationButton!: string;

  @Input() buttonColor!: ButtonColor;

  @Input() cancelButtonName!: string;

  @Input() checkBoxTitle!: string;

  checkBoxValue = false;

  constructor(public readonly activeModal: NgbActiveModal) {}
}
